export const locales = ['en', 'lv', 'ru'];
